import styled from 'styled-components';
import { device } from '../../../constants/device-sizes';

export const ModalWrapper = styled.div`
  width: 95%;
  max-width: 700px;
  padding: 1rem;
  max-height: 90vh;
  overflow-y: auto;
  @media ${device.tablet} {
    width: 85%;
    max-width: 800px;
    padding: 1.5rem;
  }
`;

export const ModalContent = styled.div`
  padding: 2rem;
  background: var(--clr-bg);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3), 0 8px 16px rgba(0, 0, 0, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  }

  @media ${device.tablet} {
    padding: 2.5rem;
  }
`;

export const ModernTitle = styled.h1`
  text-align: center;
  color: var(--clr-sec);
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);

  @media ${device.tablet} {
    font-size: 2.5rem;
  }
`;

export const ModernSubtitle = styled.p`
  text-align: center;
  color: var(--clr-sec);
  font-size: 1rem;
  font-style: italic;
  margin-bottom: 1.5rem;
  font-weight: 400;

  @media ${device.tablet} {
    font-size: 1.2rem;
  }
`;

export const ModernButton = styled.button`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 12px;
  color: white;
  font-size: 1rem;
  font-weight: 600;
  padding: 0.875rem 2rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
  position: relative;
  overflow: hidden;
  min-width: 120px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
    );
    transition: left 0.5s;
  }

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 12px 25px rgba(102, 126, 234, 0.4);

    &::before {
      left: 100%;
    }
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: 0 8px 20px rgba(102, 126, 234, 0.15);
  }

  @media ${device.tablet} {
    font-size: 1.1rem;
    padding: 1rem 2.5rem;
  }
`;

export const ModernButtonSecondary = styled(ModernButton)`
  background: transparent;
  border: 2px solid rgba(255, 255, 255, 0.2);
  color: var(--clr-sec);
  box-shadow: none;

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.3);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  }
`;

export const FeatureSection = styled.div`
  margin-bottom: 1.5rem;
`;

export const FeatureList = styled.div`
  text-align: left;
  margin: 1.5rem 0;
  padding: 1.25rem;
  background: rgba(102, 126, 234, 0.05);
  border-radius: 12px;
  border: 1px solid rgba(102, 126, 234, 0.1);
`;

export const FeatureItem = styled.div`
  color: var(--clr-sec);
  font-size: 0.95rem;
  padding: 0.25rem 0;
  padding-left: 1.5rem;
  position: relative;
  line-height: 1.4;

  &::before {
    content: '✨';
    position: absolute;
    left: 0;
    top: 0.25rem;
    font-size: 0.9rem;
  }

  @media ${device.tablet} {
    font-size: 1rem;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
`;

export const CloseButton = styled.button`
  cursor: pointer;
  position: absolute;
  width: 1.5rem;
  height: 1.5rem;
  top: 1.5rem;
  right: 1.5rem;
  font-size: 1.5rem;
  transition: all 0.3s ease;
  color: var(--clr-sec);
  opacity: 0.7;
  z-index: 10;
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: var(--clr-prim);
    opacity: 1;
    transform: scale(1.1);
  }
`;
